import { Link } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";

const SUPPORT_EMAIL = "pathmentorai@gmail.com";
const SUPPORT_PHONE = "(857) 520-3500";

export default function Privacy() {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text)" }}>
      <div className="max-w-2xl mx-auto px-5 py-10">
        <div className="flex items-center justify-between mb-8">
          <Link to="/" className="flex items-center gap-2" data-testid="privacy-logo">
            <Compass className="w-6 h-6" /><span className="font-head font-extrabold text-lg">Path Mentor</span>
          </Link>
          <Link to="/" className="pm-btn-ghost text-sm flex items-center gap-1.5" data-testid="privacy-back"><ArrowLeft className="w-4 h-4" /> Back</Link>
        </div>

        <h1 className="font-head font-extrabold text-3xl sm:text-4xl tracking-tight">Privacy Policy</h1>
        <p className="label-mono mt-2">Last updated: June 2026</p>

        <div className="mt-6 space-y-5 text-sm leading-relaxed" style={{ color: "var(--text-2)" }} data-testid="privacy-content">
          <p>Path Mentor is an education and planning tool. This policy explains what we collect, why, and your choices. We do not sell your personal information.</p>

          <Section title="What we collect">
            Account email and password (passwords are stored hashed). Your intake answers (hours, cash, goals, skills, fears). Your location — either GPS coordinates you approve or a city you type — which we reverse-geocode to a city/region to tailor suggestions. Photos you scan or measure are sent to our AI provider for analysis. Chats, tasks, paths, estimates, pins, and invoices you create.
          </Section>

          <Section title="How we use it">
            To generate local ideas, cost/earn estimates, license and training links, and to remember your active path. Location is used only to tailor suggestions and local links; we do not stream or track your location in the background.
          </Section>

          <Section title="AI processing">
            Photos and text you submit are processed by third-party AI providers (e.g. OpenAI) to produce results. Do not upload images of private individuals as products or any information you consider confidential.
          </Section>

          <Section title="Payments">
            Subscriptions are processed by Stripe. We store your plan status and a payment reference, not your full card details.
          </Section>

          <Section title="Your choices & control">
            You can edit or delete your stored location, delete individual sessions, pins, estimates, and invoices, clear your chat history, and delete your entire account and its data at any time from Settings.
          </Section>

          <Section title="Data retention">
            We keep your data until you delete it or your account. Deleting your account removes your sessions, messages, tasks, requirements, estimates, pins, and invoices.
          </Section>

          <Section title="Contact">
            Questions or requests? Email <a href={`mailto:${SUPPORT_EMAIL}`} className="underline" style={{ color: "#2563eb" }} data-testid="privacy-support-email">{SUPPORT_EMAIL}</a> or call <a href="tel:+18575203500" className="underline" style={{ color: "#2563eb" }} data-testid="privacy-support-phone">{SUPPORT_PHONE}</a>.
          </Section>

          <p className="pt-4" style={{ color: "var(--text-2)" }}>Path Mentor provides education and planning only — not financial, legal, tax, or contractor advice. Dollar figures are rough local ranges and licenses depend on your location.</p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-head font-bold text-base" style={{ color: "var(--text)" }}>{title}</h2>
      <p className="mt-1">{children}</p>
    </div>
  );
}
